export function etLoadSiteLibraryData({isMasterLibrary, isSiteLibrary}){

	let idsite = localStorage.getItem("etLibrarySite")
	let siteName = localStorage.getItem("etLibrarySiteName")

	return {
        idsite, isMasterLibrary, isSiteLibrary, siteName
    }

}